import { INDIVIDUAL_ID_SEPARATOR, LANGUAGE_SEPARATOR, ConsentsQueryParams } from './constants';
export function isConsentsSubscriptionConfirmationEmpty(props) {
    return !props.backgroundImage || !props.subscriptionsLink || !props.subscriptionManagerLink;
}
export function getConsentsQueryParams() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return {
        status: (urlSearchParams.get(ConsentsQueryParams.STATUS) ?? '').toLowerCase(),
        language: urlSearchParams.get(ConsentsQueryParams.LANGUAGE),
        individualId: urlSearchParams.get(ConsentsQueryParams.INDIVIDUAL_ID),
    };
}
export function getConsentsSubscriptionLink(subscriptionsLink, subscriptionManagerLink, language, individualId) {
    if (!individualId || !language) {
        return subscriptionsLink;
    }
    return subscriptionManagerLink
        .replace(LANGUAGE_SEPARATOR, language)
        .replace(INDIVIDUAL_ID_SEPARATOR, individualId);
}
